import axios from "./axiosInstance";
import {
  UserApiResponse,
  UserDetailsApiResponse,
  UserCreatePayload,
  UserUpdatePayload,
  UserSearchParams,
  PaginatedUserApiResponse
} from "../types/userManagementTypes";

/**
 * Create a new user
 */
export const createUser = async (payload: UserCreatePayload): Promise<UserApiResponse> => {
  const response = await axios.post<UserApiResponse>("/user-management", payload);
  return response.data;
};

/**
 * Search users with optional parameters
 */
export const searchUsers = async (params: UserSearchParams): Promise<PaginatedUserApiResponse> => {
  const response = await axios.get<PaginatedUserApiResponse>("/user-management/search", { params });
  return response.data;
};

/**
 * Fetch all users
 */
export const getAllUsers = async (filters: { [key: string]: string | number | null } = {}): Promise<PaginatedUserApiResponse> => {
  const response = await axios.get<PaginatedUserApiResponse>("/user-management", { params: { ...filters, page: 1, limit: 10 } });
  return response.data;
};

/**
 * Fetch a specific user by ID
 */
export const getUserById = async (userId: string): Promise<UserDetailsApiResponse> => {
  const response = await axios.get<UserDetailsApiResponse>(`/user-management/${userId}`);
  return response.data;
};

/**
 * Update an existing user
 */
export const updateUser = async (userId: string, payload: UserUpdatePayload): Promise<UserApiResponse> => {
  const response = await axios.put<UserApiResponse>(`/user-management/${userId}`, payload);
  return response.data;
};

/**
 * Delete a user
 */
export const deleteUser = async (userId: string): Promise<UserApiResponse> => {
  const response = await axios.delete<UserApiResponse>(`/user-management/${userId}`);
  return response.data;
};